import React from "react";
import { Helmet } from "react-helmet";

const ContactPage = ({ setCurrentPage }) => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Contact OpticPicker</title>
        <meta name="description" content="Get in touch with the OpticPicker team. Questions, feedback, or partnership inquiries welcome." />
        <meta property="og:title" content="Contact OpticPicker" />
        <meta property="og:url" content="https://www.opticpicker.com/contact" />
        <link rel="canonical" href="https://www.opticpicker.com/contact" />
      </Helmet>
      <div className="max-w-4xl mx-auto px-6 py-20">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
            Get In Touch
          </h1>
          <p className="text-xl text-gray-300">
            Have questions or suggestions? We'd love to hear from you!
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-gray-800/40 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-8">
            <h2 className="text-2xl font-bold text-white mb-6">
              Send us a message
            </h2>
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Name
                </label>
                <input
                  type="text"
                  placeholder="Your name"
                  className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600/50 rounded-xl text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="your@email.com"
                  className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600/50 rounded-xl text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Message
                </label>
                <textarea
                  rows="5"
                  placeholder="Your message..."
                  className="w-full px-4 py-3 bg-gray-700/50 border border-gray-600/50 rounded-xl text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition resize-none"
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full px-6 py-3 bg-blue-600 hover:bg-blue-500 text-white font-semibold rounded-xl transition shadow-lg shadow-blue-600/30"
              >
                Send Message
              </button>
            </form>
          </div>

          <div className="space-y-6">
            <div className="bg-gray-800/40 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-white mb-4">📧 Email</h3>
              <p className="text-gray-300">opticpicker@gmail.com</p>
              <p className="text-gray-400 text-sm mt-2">
                We typically respond within 24 hours
              </p>
            </div>

            <div className="bg-gray-800/40 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-white mb-4">💬 Feedback</h3>
              <p className="text-gray-300 mb-4">
                We're constantly improving OpticPicker! Let us know:
              </p>
              <ul className="text-gray-300 space-y-2 text-sm">
                <li>• Optics you'd like us to add</li>
                <li>• Retailers we should include</li>
                <li>• Feature requests</li>
                <li>• Bug reports</li>
              </ul>
            </div>

            <div className="bg-gray-800/40 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-8">
              <h3 className="text-xl font-bold text-white mb-4">
                🔗 Business Inquiries
              </h3>
              <p className="text-gray-300">
                Interested in partnering with OpticPicker? Contact us at
                opticpicker@gmail.com
              </p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <button
            onClick={() => setCurrentPage("browse")}
            className="px-8 py-4 bg-gray-700/50 hover:bg-gray-700 text-white font-semibold rounded-xl transition border border-gray-600/50"
          >
            ← Back to Browse
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
